import * as actions from './actions';
import { ResourceCollectionsAPIResponse } from 'store/collections/types';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { AjaxResponse } from 'rxjs/ajax';
import { Epic } from 'redux-observable';
import { RootAction } from 'store/actions';
import { RootDependencies } from 'store/dependencies';
import { RootState } from 'store/reducer';
import { isActionOf } from 'typesafe-actions';
import { of } from 'rxjs';
import { transformErrorIntoSerializableError } from 'store/utils';

export const getResourceCollectionsEpic: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(actions.getResourceCollections.request)),
    withLatestFrom(state$),
    switchMap(([{ payload }, state]) => {
      const { buildingUuid, companyUuid, lang, include } = payload;

      return apiClient(state)
        .getResourceCollections(buildingUuid, companyUuid, lang, include)
        .pipe(
          map(({ response }: AjaxResponse<ResourceCollectionsAPIResponse>) => {
            return actions.getResourceCollections.success({
              collections: response.collections,
            });
          }),
          catchError((error: Error) =>
            of(actions.getResourceCollections.failure({ error: transformErrorIntoSerializableError(error) })),
          ),
        );
    }),
  );
